/**
 * PACE brand mark: three plan bars of a Gantt chart ending in a green milestone diamond
 * (the tool shipped on time). Drawn in currentColor so it works on any background.
 */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <g fill="currentColor">
        <rect x="2" y="5" width="15" height="5.4" rx="2.7" />
        <rect x="8" y="13.3" width="13" height="5.4" rx="2.7" />
        <rect x="4" y="21.6" width="11" height="5.4" rx="2.7" />
      </g>
      <rect
        x="21.2"
        y="20.2"
        width="7.4"
        height="7.4"
        rx="1.4"
        transform="rotate(45 24.9 23.9)"
        fill="#2BB36A"
        stroke="currentColor"
        strokeWidth="1.4"
      />
    </svg>
  );
}
